const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
const revealTargets = [
  ...document.querySelectorAll(
    [
      ".wtc-hero__content",
      ".wtc-brief__content",
      ".wtc-steps h2",
      ".wtc-step-card",
      ".wtc-benefits h2",
      ".wtc-benefit-card",
      ".wtc-section-heading",
      ".wtc-compare__scroll",
      ".wtc-program-section__header",
      ".wtc-program-card",
      ".wtc-faq h2",
      ".wtc-faq details",
    ].join(",")
  ),
];

document.documentElement.classList.add("wtc-motion-ready");

const revealGroups = new Map();
revealTargets.forEach((element) => {
  element.classList.add("wtc-reveal");
  const group = revealGroups.get(element.parentElement) || [];
  group.push(element);
  revealGroups.set(element.parentElement, group);
});

revealGroups.forEach((elements) => {
  elements.forEach((element, index) => {
    element.style.setProperty("--wtc-reveal-delay", `${Math.min(index * 70, 280)}ms`);
  });
});

if (reducedMotion.matches || !("IntersectionObserver" in window)) {
  revealTargets.forEach((element) => element.classList.add("is-visible"));
} else {
  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        revealObserver.unobserve(entry.target);
      });
    },
    {
      rootMargin: "0px 0px -8% 0px",
      threshold: 0.08,
    }
  );

  window.requestAnimationFrame(() => {
    revealTargets.forEach((element) => revealObserver.observe(element));
  });
}

const faqItems = [...document.querySelectorAll(".wtc-faq details")];
const closeTimers = new WeakMap();

function setFaqState(item, expanded) {
  window.clearTimeout(closeTimers.get(item));

  if (expanded) {
    item.open = true;
    window.requestAnimationFrame(() => item.classList.add("is-expanded"));
    return;
  }

  item.classList.remove("is-expanded");
  const delay = reducedMotion.matches ? 0 : 320;
  const timer = window.setTimeout(() => {
    item.open = false;
    closeTimers.delete(item);
  }, delay);
  closeTimers.set(item, timer);
}

faqItems.forEach((item) => {
  const summary = item.querySelector("summary");

  summary.addEventListener("click", (event) => {
    event.preventDefault();
    const shouldExpand = !item.open || !item.classList.contains("is-expanded");

    faqItems.forEach((otherItem) => {
      if (otherItem !== item && otherItem.open) setFaqState(otherItem, false);
    });

    setFaqState(item, shouldExpand);
  });
});
